export function parseUrl(url: string) {
  try {
    return new URL(url)
  } catch {
    return null
  }
}

export function safeDecodeUriComponent(value: string) {
  try {
    return decodeURIComponent(value)
  } catch {
    return value
  }
}

/**
 * Removes org-scoped entity selection query params when switching accounts.
 * List/filter params are preserved; only the open-panel selection IDs are cleared.
 */
export function stripEntitySelectionQueryParams({
  pathname,
  suffix,
}: {
  pathname: string
  suffix: string
}) {
  if (suffix === '' || !suffix.startsWith('?')) {
    return suffix
  }

  const routeLeaf = pathname.split('/').filter(Boolean).at(-1)
  const keysToStrip = getEntitySelectionQueryParamKeys(routeLeaf)
  if (keysToStrip === null) {
    return suffix
  }

  const hashIndex = suffix.indexOf('#')
  const queryString =
    hashIndex === -1 ? suffix.slice(1) : suffix.slice(1, hashIndex)
  const hash = hashIndex === -1 ? '' : suffix.slice(hashIndex)

  const params = new URLSearchParams(queryString)
  for (const key of keysToStrip) {
    params.delete(key)
  }

  const nextQuery = params.toString()
  if (nextQuery === '') {
    return hash
  }

  return `?${nextQuery}${hash}`
}

function getEntitySelectionQueryParamKeys(routeLeaf: string | undefined) {
  if (routeLeaf === 'dropbox') {
    return ['dropbox_id']
  }

  if (routeLeaf === 'inbox' || routeLeaf === 'cases') {
    return ['case_id']
  }

  if (routeLeaf === 'faxes') {
    return ['inbound_fax_id']
  }

  return null
}
